var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "k-form", class: { loading: _vm.isLoading } },
    [
      _c("div", { staticClass: "form-body" }, [_vm._t("default")], 2),
      _c(
        "transition",
        { attrs: { name: "fade", appear: "" } },
        [_vm.isLoading && !_vm.isMainLoading ? _c("d-loading") : _vm._e()],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }